import React, { useState } from 'react'
import './styles.scss'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'
import { Button } from 'components/Form'

const StateChannelCard = ({ conversation, operator, onClickExit, handleClickJoin }) => {
  const [exit, setExit] = useState(false)
  const { users } = conversation
  const isJoined = users.includes(operator)
  return (
    <div
      className='state-channel-container'
      onMouseLeave={() => setExit(false)}
    >
      {isJoined
        ? <div
          className='state-channel-container__icon-text'
          onMouseOver={() => setExit(true)}
          onMouseLeave={() => setExit(false)}
        > {
            exit
              ? <button onClick={() => onClickExit(conversation)}>{lang('dashboard_leave')}</button>
              : <>
                <img
                  src={getStaticImage('/icons/orange-brand/icon-check-green.svg')}
                  alt={lang('dashboard_unit')}
                />
                <span>{lang('dashboard_unit')}</span>
              </>
          }
        </div>
        : <Button
          className={'state-channel-container__button-join'}
          secondary
          value={lang('dashboard_join')}
          onClick={() => handleClickJoin(conversation)}
          isSubmitting={false}
        />
      }
    </div>
  )
}

export default StateChannelCard